import styled from "styled-components";

const StyledHero = styled.header`
  background: url(${(props) => props.img});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 450px;
`;

export default StyledHero;
